// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue';
import Vuex from 'vuex';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueObserveVisibility from 'vue-observe-visibility';
import App from './App';
import router from './router';

Vue.config.productionTip = false;
window.$ = window.jQuery = require('jquery');

Vue.use(Vuex);
Vue.use(VueObserveVisibility);

// Store
const store = new Vuex.Store({
  state: {
    products: [],
    specialProducts:[],
    stepValues: [],
    fallbackId: "",
  },
  mutations: {
    refreshProducts(state) {
      state.products = [];
      state.specialProducts.forEach(specialProduct => {
        state.products.push(specialProduct);
      });
      state.stepValues.forEach(stepValue => {
        if ((typeof stepValue.articleIds != "undefined") && stepValue.articleIds != null) {
          let articleIds = stepValue.articleIds.split(';');
          let articleQuantities = stepValue.articleQuantities.split(';');
          if (Array.isArray(articleIds)) {
            for (let i = 0; i < articleIds.length; ++i) {
              let product = {
            
              };
              product.articleId = articleIds[i];
              product.articleQuantity = parseFloat(articleQuantities[i]);
              // Check if product exists
              let productExists = false;
              for (let k = 0; k < state.products.length; ++k) {
                if (state.products[k].articleId == product.articleId) {
                  state.products[k].articleQuantity += product.articleQuantity;
                  productExists = true;
                  break;
                }
              }
              if (!productExists) {
                state.products.push(product);
              }
            }
          } else {
            let product = {
            
            };
            product.articleId = articleIds;
            product.articleQuantity = parseFloat(articleQuantities);
            // Check if product exists
            let productExists = false;
            for (let k = 0; k < state.products.length; ++k) {
              if (state.products[k].articleId == product.articleId) {
                state.products[k].articleQuantity += product.articleQuantity;
                productExists = true;
                break;
              }
            }
            if (!productExists) {
              state.products.push(product);
            }
          }
        }
      });
    },
    addSpecialProduct (state, specialProduct) {
      // Check if special product exists
      for (let i = 0; i < state.specialProducts.length; ++i) {
        if (state.specialProducts[i].articleId == specialProduct.articleId) {
          state.specialProducts[i].articleQuantity += specialProduct.articleQuantity;
          return;
        }
      }
      state.specialProducts.push(specialProduct);
    },
    addStepValue (state, stepValue) {
      state.stepValues.push(stepValue);
    },
    replaceStepValues(state, newStepValues) {
      // This function is called, when a configuration is loaded
      store.commit('deleteAllStepValues');
      newStepValues.forEach(element => {
        state.stepValues.push(element);
      });
    },
    replaceProducts(state, newProducts) {
      // This function is called, when a configuration is loaded
      store.commit('deleteAllProducts');
      newProducts.forEach(element => {
        state.products.push(element);
      });
    },
    replaceSpecialProducts(state, newSpecialProducts) {
      store.commit('deleteAllSpecialProducts');
      newSpecialProducts.forEach(element => {
        state.specialProducts.push(element);
      });
    },
    deleteSpecificStep(state, stepId) {
      for (let i = 0; i < state.stepValues.length; i++) {
        if (state.stepValues.at(i).stepId == stepId) {
          state.stepValues.splice(i, 1);
          --i;
        }
      }
    },
    deleteAllStepValues(state) {
      state.stepValues = [];
    },
    deleteAllProducts(state) {
      state.products = [];
    },
    deleteAllSpecialProducts(state) {
      state.specialProducts = [];
    }
  },
  getters: {
    isValueFound: (state) => (value) => {
      var found = false;
      state.stepValues.forEach( element => {
        if (element.value == value) {
          found = true;
        }
      });
      return found;
    },
    findByValueName: (state) => (name) => {
      let returnValue = "";
      state.stepValues.forEach( element => {
        if (element.valueName == name) {
           returnValue = element;
        }
      });
      return returnValue;
    },
    findByAttributeName: (state) => (name) => {
      let returnValue = "";
      state.stepValues.forEach( element => {
        if (element.attributeName == name) {
           returnValue = element;
        }
      });
      return returnValue;
    },
    findByAttributeNameAndStepName: (state) => (name, stepnamePart) => {
      let returnValue = "";
      state.stepValues.forEach( element => {
        if (element.attributeName == name && element.stepName.includes(stepnamePart)) {
           returnValue = element;
        }
      });
      return returnValue;
    },
  },
});

// Vue-Html-To-Paper
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    './static/css/overview/print.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
};

Vue.use(VueHtmlToPaper, options);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js